
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/behavior/suggestions",
      function () {
        return require("private-next-pages/x/react-chat/behavior/suggestions.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/behavior/suggestions"])
      });
    }
  